import { styled } from "@mui/material";
import MainCard from "../MainCard";
import { colors } from "../../../utility/types/constant";

export const CardWrapper = styled(MainCard)(({ theme }) => ({
  backgroundColor: colors.primary,
  color: "#fff",
  overflow: "hidden",
  position: "relative",
  "&:after": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: colors.primary,
    borderRadius: "50%",
    top: -85,
    right: -95,
    [theme.breakpoints.down("sm")]: {
      top: -105,
      right: -140,
      background: colors.primary,
    },
  },
  "&:before": {
    content: '""',
    position: "absolute",
    width: 210,
    height: 210,
    background: colors.primary,
    borderRadius: "50%",
    top: -125,
    right: -15,
    opacity: 0.5,
    [theme.breakpoints.down("sm")]: {
      top: -155,
      right: -70,
      background: colors.primary,
    },
  },
  [theme.breakpoints.down("sm")]: {
    margin: theme.spacing(3),
    height: 205,
  },
}));
